import { local } from '@/local';
export default {
  hasPersonalAddress: {
    paramNames: ['hasPersonalAddress'],
    validate: (value, { hasPersonalAddress }) => hasPersonalAddress === 'true',
    getMessage: () => local.requestReply.checkAddressError,
  },
};
